import type { PropsWithChildren } from "react"
import { isDev } from "@/utils/env"

export function DevOnly({ children }: PropsWithChildren) {
  return isDev ? children : null
}
